const DEFAULT_FLOW_POINT_CHECKS = {
  name: false,
  nodeName: false,
};

const DEFAULT_START_NODE_CHECKS = {
  name: false,
  type: false,
};

export const normalizeFlowStartingPointsForForm = (
  flowStartingPoints: unknown,
) => {
  if (!Array.isArray(flowStartingPoints)) {
    return [];
  }

  return flowStartingPoints.map((point) => {
    if (!point || typeof point !== 'object') {
      return {
        name: '',
        nodeName: null,
        checks: { ...DEFAULT_FLOW_POINT_CHECKS },
      };
    }

    const typedPoint = point as Record<string, unknown>;

    return {
      name: String(typedPoint.name ?? ''),
      nodeName:
        typedPoint.nodeName === null || typedPoint.nodeName === undefined
          ? null
          : String(typedPoint.nodeName),
      checks: {
        ...DEFAULT_FLOW_POINT_CHECKS,
        ...(typedPoint.checks && typeof typedPoint.checks === 'object'
          ? typedPoint.checks
          : {}),
      },
    };
  });
};

export const normalizePrototypeStartNodeForForm = (
  prototypeStartNode: unknown,
) => {
  if (!prototypeStartNode || typeof prototypeStartNode !== 'object') {
    return null;
  }

  const typedNode = prototypeStartNode as Record<string, unknown>;

  return {
    name: String(typedNode.name ?? ''),
    type: String(typedNode.type ?? ''),
    checks: {
      ...DEFAULT_START_NODE_CHECKS,
      ...(typedNode.checks && typeof typedNode.checks === 'object'
        ? typedNode.checks
        : {}),
    },
  };
};

import { ensureReactionChecks } from '../components/MainSettings/components/PrototypeProperties/PrototypeProperties.helpers';

export const normalizeReactionsForForm = (reactions: unknown) => {
  if (!Array.isArray(reactions)) {
    return [];
  }

  return reactions.map((reaction) => {
    if (!reaction || typeof reaction !== 'object') {
      return ensureReactionChecks({
        action: null,
        trigger: null,
        checks: {},
      });
    }

    const typedReaction = reaction as Record<string, unknown>;

    return ensureReactionChecks({
      action: typedReaction.action ?? null,
      trigger: typedReaction.trigger ?? null,
      checks:
        typedReaction.checks && typeof typedReaction.checks === 'object'
          ? typedReaction.checks
          : {},
    });
  });
};
